import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

// import { CustomFieldContainer } from "../../../../Container/Application";

// import { filter4xxAnd503Error } from "../../../../utils";

import { AlertErrorComponent } from '../Error/Error';
import {
  CheckBoxNormalView,
  DateTime,
  DropDownNormalView,
  FileUpload,
  LinearScaleNormalView,
  MulitpleChoiseNormalView,
  NumberView,
  ParagraphNormalView,
  RatingNormalView,
  TextView,
} from '../QuestionComponents';

function CustomFieldGrid({
  positionData, // passing
  positionID, // will pass
  isReferral = false, // optional
  handleCustomFromData = () => {}, // passing
  globalStateData, // optional
  isEditApplication, // optional
  setCustomFieldsValidation,
  setCustomFormData,
}) {
  const customFormData = positionData?.data?.customFormData ?? [];
  // const [fieldsArray, setCustomFeildArray] = useState();
  // const [questionLookup, setQuestionLookup] = useState({});
  const [error, setError] = useState({
    error: false,
    message: 'something went wrong!!',
  });
  // const handleCloseError = () => {
  //   setError({ error: false, message: "something went wrong!!" });
  // };

  // ! Initialize, initial validation status -

  useEffect(() => {
    setCustomFormData(positionData?.data?.customFormData);
  }, [positionData?.data]);

  useEffect(() => {
    const initialValidationState = customFormData.reduce((acc, item) => {
      // ? this check endures, only the custom fiels which are eligible for validation to be added in the validation logic
      if (
        item.fieldType === 'NUMBER' ||
        item.fieldType === 'TEXT' ||
        item.fieldType === 'PARAGRAPH' ||
        item.fieldType === 'UPLOAD FILE'
      ) {
        acc[item.fieldName] = true; // format validity — presence is checked separately by isAnyRequiredCustomFieldEmpty
      }
      return acc;
    }, {});
    setCustomFieldsValidation(initialValidationState);
  }, [positionData?.data]);

  const componentMap = {
    NUMBER: NumberView,
    TEXT: TextView,
    'DROP DOWN': DropDownNormalView,
    PARAGRAPH: ParagraphNormalView,
    'MULTIPLE CHOICE': MulitpleChoiseNormalView,
    'CHECK BOX': CheckBoxNormalView,
    'LINEAR SCALE': LinearScaleNormalView,
    RATING: RatingNormalView,
    'DATE AND TIME': DateTime,
    'UPLOAD FILE': FileUpload,
  };

  const getComponent = (type, props) => {
    const Component = componentMap[type] ?? (() => null);
    return <Component {...props} />;
  };

  useEffect(() => {
    if (!isEditApplication) {
      if (positionData && Object.keys(positionData)?.length > 0) {
        const objStructure = customFormData.map((item) => ({
          fieldName: item.fieldName, // Correctly accessing fieldName
        }));

        handleCustomFromData(objStructure, -1, true);
      }
    }
  }, [positionData?.data]); // Added `customFormData` as a dependency

  return (
    <Grid item xs={12} md={12} style={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
      {error?.error && (
        <AlertErrorComponent
          message={error?.message}
          // handleClose={handleCloseError}
        />
      )}
      {customFormData.map((customField, ind) => (
        <div key={ind}>
          {getComponent(customField?.fieldType, {
            data: customField,
            setError,
            ind,
            setData: handleCustomFromData,
            isRequired: !isReferral && customField?.required,
            globalStateData,
            setCustomFieldsValidation,
          })}
        </div>
      ))}
    </Grid>
  );
}
export default function CustomFieldGridWrapper(props) {
  return (
    // <CustomFieldContainer {...props}>
    <CustomFieldGrid {...props} />
    // </CustomFieldContainer>
  );
}
